export default "__VITE_ASSET__7e3yA1K1__"